import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PestControlIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pest_control"}/>
}
